export default {
  state: {
    list: [],
    showCreate: false,
    showConfirm: false,
  },
  mutations: {
    setListData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/insurance/list.js